import Segmentation from './Segmentation';

export default Segmentation;
